import * as dev from './dev'
import * as test from './test'
import * as prod from './prod'

export default function () {
  // 当前环境
  let env = 'prod'
  const { host } = window.location
  if (host.search(/dev|localhost|192.|127./) > -1)
    env = 'dev'
  else if (host.search('test.') > -1)
    env = 'test'

  // console.log('====env====', env)

  switch (env) {
    case 'dev': {
      return dev
    }
    case 'test': {
      return test
    }
    default: {
      return prod
    }
  }
}
